import { render, staticRenderFns } from "./ModalCommentaireStallionTiers.vue?vue&type=template&id=2eb45409&"
import script from "./ModalCommentaireStallionTiers.vue?vue&type=script&lang=js&"
export * from "./ModalCommentaireStallionTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports